import { render, staticRenderFns } from "./PartnerHighlightCard.vue?vue&type=template&id=50213cdc&scoped=true&"
import script from "./PartnerHighlightCard.vue?vue&type=script&lang=js&"
export * from "./PartnerHighlightCard.vue?vue&type=script&lang=js&"
import style0 from "./PartnerHighlightCard.vue?vue&type=style&index=0&id=50213cdc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50213cdc",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VImg,VRow})
